import React from 'react';
import { Card } from 'react-bootstrap';
import moment from 'moment';
import Linkify from 'react-linkify';
import LinkifyIt, { Match } from 'linkify-it';
import tlds from 'tlds';

import { GetMemoDto } from '../../../common/snrwbCore/autogenerated/snrwbApiClient';
import { empolyeeName } from '../../../common/snrwbCore/contexts/EmployeeContext';
import TooltipText from '../../../app/components/TooltipText';

import Pulse from './Pulse';

const linkify = new LinkifyIt();
linkify.tlds(tlds);
const matchDecorator = (text: string): Match[] | null => {
  const matches = linkify.match(text);
  if (!matches) {
    return matches;
  }

  const filtered = matches.filter(
    m => m.raw && !m.raw.toLowerCase().includes('wwb.'),
  );
  return filtered.length === 0 ? null : filtered;
};

export const MemoCard = (props: { memo: GetMemoDto }) => {
  if (!props.memo) {
    return <></>;
  }
  const unread = props.memo.unread.toString() === 'true';
  const sent = props.memo.sent.toString() === 'true';
  return (
    <Card
      className={
        (sent ? 'ms-auto' : 'me-auto') + (props.memo.first ? '' : ' mt-1')
      }
    >
      <Card.Header
        className={
          'd-flex' +
          (unread ? ' fw-bold' : '') +
          (sent
            ? ' bg-light text-dark flex-row-reverse'
            : ' bg-success text-dark bg-opacity-25')
        }
      >
        <span className={sent ? undefined : 'flex-fill me-4'}>
          {unread && <Pulse variant="green" />}
          <span className={unread ? ' ms-1' : ''}>
            {empolyeeName(props.memo.sender)}
          </span>
        </span>
        <span className={sent ? 'flex-fill me-4' : undefined}>
          <TooltipText
            text={moment(props.memo.date).fromNow()}
            tooltip={moment(props.memo.date).calendar()}
          />
        </span>
      </Card.Header>
      <Card.Body>
        <Card.Text>
          <Linkify matchDecorator={matchDecorator}>
            {props.memo.content}
          </Linkify>
        </Card.Text>
      </Card.Body>
    </Card>
  );
};
